import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { gAService, RightColumnBannerStore } from 'eTip--common';
import * as stores from '../../stores';
import { RightBannerContainer } from './rightBannerContainer';
import { Instance } from 'mobx-state-tree';

export interface IRightBannersProps { //expected to be store here, similar to others
    applicationStore?: { rightColumnBanners: Instance<typeof RightColumnBannerStore> };
}

@inject(stores.ApplicationStoreKey)
@observer
export class RightBannersContainer extends React.Component<IRightBannersProps> {

    constructor(props: IRightBannersProps) {
        super(props);
    }

    render() {
        const store = this.props.applicationStore.rightColumnBanners;
        if (store.items) {
            return (
                store.items.map((item) => (
                    <RightBannerContainer
                        key={item.id}
                        title={item.title}
                        imgSrc={item.imgUrl}
                        imgWidth={item.width}
                        imgHeight={item.height}
                        asNewWindow={item.asNewWindow}
                        onClick={() => {
                            gAService.sendEvent("RightColumnBanner", 'open', item.title);
                            if (item.asNewWindow) {
                                window.open(item.linkUrl, "_blank");
                            } else {
                                document.location.href = item.linkUrl;
                            }
                        }
                        } />)));
        } else {
            return null;
        }
    }
}